<template>
  <div class="send-content">
    <el-row :gutter="20">
      <el-col :span="8">
        <div class="sendList">
          <div class="send-List">
            <div class="sendItems" v-for="(item,index) in sendList" :key="item.id">
              <div class="sendDivList">
                <div
                  v-if="index === 0"
                  class="sendFirst"
                  :style="{backgroundImage:'url('+item.cover+')'}"
                >
                  <div class="firstTitle">{{item.articletitle}}</div>
                </div>
                <div v-else class="sendOther">
                  <div class="otherTitle">{{item.articletitle}}</div>
                  <div class="sendOtherPic" :style="{backgroundImage:'url('+item.cover+')'}"></div>
                </div>
              </div>
              <div class="sendListHandler">
                <div class="send-handler" @click="moveForward(index)">
                  <i class="el-icon-upload2 send-handler-icon"></i>
                </div>
                <div class="send-handler" @click="moveBack(index)">
                  <i class="el-icon-download send-handler-icon"></i>
                </div>
                <div class="send-handler" style="float: right" @click="delArticle(index)">
                  <i class="el-icon-delete-solid send-handler-icon"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="sendFooter">
            <el-button
              class="send-btn"
              :disabled="loading"
              type="primary"
              :loading="loading"
              @click="checkSend"
            >
              <span v-if="!loading">发送至</span>
              <span v-else>推送中...</span>
            </el-button>
            <el-checkbox-group v-model="target" class="send-checkbox">
              <el-checkbox label="gzh">
                <span>公众号</span>
              </el-checkbox>
              <el-checkbox label="miniprogram">
                <span>app</span>
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </el-col>
      <el-col :span="16">
        <div class="sendHistory" v-loading="sentLoading"  element-loading-text="Loading" element-loading-spinner="el-icon-loading">
          <div class="sub-head">
            <span>推送历史</span>
          </div>
          <div class="sentList-box">
            <el-scrollbar style="height: 100%" ref="myScrollbar">
              <el-row
                :gutter="30"
                v-for="(item,index) in sendhistory"
                :key="index"
                class="resultItem"
              >
                <el-col :span="4">
                  <div class="sendState divInline">
                    <div class="stateInfo">
                      <div class="stateDate">{{item.sendtime | moment("YYYY-MM-DD")}}</div>
                      <div>
                        <span>状态:</span>
                        <span
                          v-if="item.sendstate == 0 || item.sendstate == '' || item.sendstate == null"
                        >发送中</span>
                        <span v-else-if="item.sendstate == 1">发送成功</span>
                        <span v-else>发送失败</span>
                      </div>
                      <div>
                        <span>成功接收人数:</span>
                        <span>{{item.sendnumber}}</span>
                      </div>
                      <div>
                        <span>接收平台:</span>
                        <span v-if="item.target === 'miniprogram'">小程序</span>
                        <span v-else>公众号</span>
                      </div>
                    </div>
                  </div>
                </el-col>
                <el-col :span="20">
                  <div class="sendInfo divInline">
                    <el-row :gutter="30">
                      <el-col :span="6">
                        <div class="sendPic divInline">
                          <div class="picDiv" :style="{backgroundImage:'url('+item.cover+')'}"></div>
                        </div>
                      </el-col>
                      <el-col :span="18">
                        <div class="sendContent divInline">
                          <div class="sendTitle">{{item.articletitle}}</div>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </el-col>
              </el-row>
            </el-scrollbar>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import api from '@/api/news/publish.js';
export default {
  data() {
    return {
      sentLoading:false,
      loading: false,
      sendhistory: [],
      target: [],
      reqData: {
        communityid: '',
        page: 1,
        rows: 10
      },
      sendPublic: true
    };
  },
  computed: {
    sendList() {
      return this.$store.state.sendList;
    },
    userInfo() {
      return this.$store.state.userInfo;
    },
    initId() {
      return this.$store.state.communityInfo.initid;
    }
  },
  mounted() {
    this.getData();
    window.addEventListener('scroll', this.onScroll, true);
  },
  destroyed: function() {
    window.removeEventListener('scroll', this.onScroll, true);
  },
  methods: {
    async getData(scroll) {
      if (scroll !== true) {
        this.sentLoading=true;
        this.reqData.page = 1;
      }
      let data = JSON.parse(JSON.stringify(this.reqData));
      data.communityid = this.userInfo.communityId;
      let res = await this.$http.get(api.sendHistory, { params: data });
      if (res && res.isSucceed) {
        this.sentLoading=false;
        if (this.reqData.page === 1) {
          this.totalPage = Math.ceil(res.total / this.reqData.rows);
        }
        if (scroll === true) {
          this.sendhistory = [...this.sendhistory, ...res.rows];
          return;
        }
        this.sendhistory = res.rows;
      }
    },
    // 滚动事件
    onScroll() {
      let dom = document.querySelector('.sentList-box .el-scrollbar__wrap');
      const scrollDistance =
        dom.scrollHeight - dom.scrollTop - dom.clientHeight;
      if (scrollDistance <= 0) {
        if (this.reqData.page >= this.totalPage) return;
        this.reqData.page++;
        this.getData(true);
      }
    },
    moveForward(index) {
      if (index === 0) return;
      this.$store.commit('CHANGE_ARTICLE_SORT',{name:'sendList',index});
    },
    moveBack(index) {
      if (index === this.sendList.length - 1) return;
      this.$store.commit('CHANGE_ARTICLE_SORT', {name:'sendList',index:index+1});
    },
    delArticle(index) {
      this.$store.commit('DEL_ARTICLE',  {name:'sendList',index});
    },
    checkSend() {
      if (!this.sendList || this.sendList.length <= 0) {
        this.$message.error('暂无可推送的文章');
        return false;
      }
      if (!this.target || this.target.length <= 0) {
        this.$message.error('请选择推送消息平台');
        return false;
      }
      let target=JSON.parse(JSON.stringify(this.target))
      if (this.target.includes('gzh')) {
         if(!this.checkCount()) target.remove('gzh');
      }
      this.sendToWechat(target)
    },
    async checkCount() {
      if (!this.initId) {
        this.$message.error('请先绑定公众号');
        return false;
      }
      let res = await this.$http.get(api.getCount, {
        params: { initId: this.initId }
      });
      if (res && res.isSucceed) {
        if (res.newPrimaryKeys.count < 0) {
          if (res.data.newPrimaryKeys['公众号类型'] === '2') {
            this.$Message.success('您本月的公众号推送数量已达上限，请下月再试');
          } else {
            this.$Message.success('您今天的公众号推送数量已达上限，请明天再试');
          }
          return false;
        }
        return true;
      }
    },

    async sendToWechat(target){
      if(!target || target.length <= 0){
        return false;
      }
      let articleids=this.sendList.map((item)=>{
        return item.id
      }).join(',')
      let data={
        articleids,
        communityid:this.userInfo.communityId,
        target:target.join(','),
        initId:this.initId
      }
       let res = await this.$http.get(api.sendArticle, {
        params:data
      });
       if (res && res.isSucceed) {
         this.$store.commit('DEL_ALL_ARTICLES','sendList')
         this.getData();
       }
    }
  }
};
</script>
<style lang='less' scoped>
@import url('./index.less');
</style>

